"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var contribution_1 = __importDefault(require("../../config/contribution"));
var event_bus_1 = require("../../event-bus");
var ContributionCheckbox = /** @class */ (function (_super) {
    __extends(ContributionCheckbox, _super);
    function ContributionCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "contribution-checkbox";
        return _this;
    }
    Object.defineProperty(ContributionCheckbox.prototype, "isChecked", {
        get: function () {
            var contributions = this.scout.contributions_profile.status;
            return (typeof contributions[this.year] !== "undefined" &&
                typeof contributions[this.year]["quarter" + this.quarter] !== "undefined" &&
                contributions[this.year]["quarter" + this.quarter] === contribution_1.default.PAID);
        },
        enumerable: true,
        configurable: true
    });
    ContributionCheckbox.prototype.onChange = function (value) {
        event_bus_1.EventBus.$emit(event_bus_1.events.contribution.update, {
            scout_id: this.scout.id,
            year: this.year,
            quarter: this.quarter,
            paid: value
        });
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ContributionCheckbox.prototype, "scout", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ContributionCheckbox.prototype, "year", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ContributionCheckbox.prototype, "quarter", void 0);
    ContributionCheckbox = __decorate([
        vue_class_component_1.default
    ], ContributionCheckbox);
    return ContributionCheckbox;
}(vue_property_decorator_1.Vue));
exports.default = ContributionCheckbox;
